<template>
  <footer>
    <hr>
    version : {{this.app.appContext.config.globalProperties.$version}} <br>
    chanqwak@naver.com &copy;
    <br>
    {{this.$store.state.liveTime}} {{this.$store.state.liveConnectCount}}명

  </footer>
</template>

<script>
import { getCurrentInstance } from '@vue/runtime-core';
export default {
  data() {
    return {
      app:"",
    }
  },
  created() {
    this.app = getCurrentInstance();
  },
}
</script>

<style>

</style>